module.exports = __webpack_public_path__ + "media/我要娶你为妻 (电影《我要我们在一起》配乐).85cde2d9.mp3";